import { ui } from '@procuros/datachecks';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { WebEDIAnnotation } from 'services/webediErrors/types';

import { MessageNonFieldErrorBanner } from '../MessageNonFieldErrorBanner/MessageNonFieldErrorBanner';

export const DocumentSectionAnnotation = ({
  path,
  sectionConfig,
}: {
  path: string;
  sectionConfig: Pick<ui.Section, 'description'>;
}) => {
  const { service } = useNavigationContext<WebEDIAnnotation>();
  const annotation = service.useItemByFieldPath(path);
  const numberOfErrors = service.useNumberOfActiveItems();
  const setCurrentItem = service.setCurrentItem;

  if (!annotation) {
    return null;
  }

  return (
    <MessageNonFieldErrorBanner
      annotation={annotation}
      totalNumberOfErrors={numberOfErrors}
      setCurrentItem={setCurrentItem}
      sectionDescription={sectionConfig.description}
    />
  );
};
